import { gql } from '@apollo/client';

export const COMMENT_LIST_QUERY = gql`
  query contentQuery($id: Int) {
    commentList(request: { id: $id, perPage: 50 }) {
      id
      parent_id
      message
      name
      date
    }
  }
`;

export interface UserComment {
  id: number;
  parent_id: number;
  message: string;
  name: string;
  date: string;
}

export interface CommentListQueryResponse {
  commentList: UserComment[];
}

export const COMMENT_MUTATION = gql`
  mutation postMutation(
    $authorName: String!
    $authorEmail: String!
    $content: String!
    $postId: Int!
    $parentId: Int = 0
  ) {
    postComment(
      author_name: $authorName
      author_email: $authorEmail
      content: $content
      post: $postId
      parent: $parentId
    ) {
      code
      id
      parent_id
      date
      message
      name
      status
    }
  }
`;

export interface CommentMutationVars {
  authorName: string;
  authorEmail: string;
  content: string;
  postId: number;
  parentId?: number;
}

export interface CommentMutationResponse {
  postComment: {
    code: number;
    id: number;
    parent_id: number;
    date: string;
    message: string;
    name: string;
    status: string;
  };
}
